import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { initializeI18n } from './i18n';
import { RTL } from './components/rtl';
import { useSettings } from './contexts/settings-context';
import { useAuth } from './hooks/use-auth';
import routes from './routes';
import { createCustomTheme } from './theme';
import ErrorBoundary from './components/error-boundary';
import './css/spinner.css';

export const App = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const { isInitialized } = useAuth();

  useEffect(() => {
    initializeI18n(settings.language);
  }, [settings]);

  const theme = createCustomTheme({
    direction: settings.direction,
    theme: settings.theme
  });

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <RTL direction={settings.direction}>
          <CssBaseline />
          {isInitialized && content}
        </RTL>
      </ThemeProvider>
    </ErrorBoundary>
  );
};
